import type { GenericPointGeometry, LngLat } from '@yandex/ymaps3-types';
import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import type { Coordinates } from '@lt/api/dist/types/map';

import styles from './clusterPoint.module.css';

const YMapMarker = loadReactComponent('YMapMarker', loadModulePromise);

type ClusterPointProps = GenericPointGeometry<LngLat> & {
  hotelCount: number;
  moveToPoint: (
    coordinates: Coordinates,
    zoomDiff: number,
    offset: { x: number; y: number },
  ) => void;
};

const ClusterPoint = (props: ClusterPointProps) => {
  const { hotelCount, moveToPoint } = props;

  const handleClick = () => {
    const { coordinates } = props;
    moveToPoint(coordinates as Coordinates, 3, { x: 0, y: 0 });
  };

  return (
    <YMapMarker onClick={handleClick} {...props} hideOutsideViewport>
      <div className={styles.clusterPoint}>{hotelCount}</div>
    </YMapMarker>
  );
};

export default ClusterPoint;
